export default __webpack_public_path__ + "static/media/15.104757d7.svg";